<template>
  <div class="backgroundDiv" style="width: 100%">
    <v-form ref="form" @submit.prevent="submit" class="height-100-p">
      <SimpleWarningDialog
        v-if="snackbar"
        id="loginErrorDialog"
        :title="$t('unexpectedErrorHappened')"
        :text="loginErrorText"
        @onPrimary="closeWarningDialog"
      />
      <v-container fluid fill-height pa-0>
        <v-row no-gutters class="height-100-p">
          <v-col :cols="0" :lg="6">
            <v-row class="height-100-p" align="center" justify="center">
              <v-col :cols="4"> </v-col>
            </v-row>
          </v-col>
          <v-col :cols="12" :lg="6">
            <v-row class="height-100-p" align="center" justify="center">
              <v-col :cols="6">
                <div
                  style="
                    background-color: hsla(0, 0%, 100%, 0.55);
                    width: 30em;
                    padding-left: 3em;
                    padding-right: 3em;
                    padding-bottom: 2em;
                    padding-top: 2em;
                    text-align: center;
                  "
                >
                  <img
                    :src="imagePath"
                    style="height: 50px; margin-bottom: 30px"
                  />
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="username"
                    outlined
                    :rules="[rules.required]"
                    color="#0032a0"
                    :label="$t('username')"
                    @keyup.enter="login"
                    @paste="onPasteUsername"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    outlined
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    :label="$t('password')"
                    @click:append="show = !show"
                    @keyup.enter="login"
                    @paste="onPastePassword"
                  ></v-text-field>
                  <v-select
                    v-if="domainList.length > 1"
                    :label="$t('domain')"
                    :items="domainList"
                    v-model="selectedDomain"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                  <v-row v-if="captchaSrc">
                    <v-col :cols="4" class="flex-center">
                      <img
                        :src="captchaSrc"
                        id="captcha_code_image"
                        class="captchaImg"
                        @click="captcha()"
                      />
                    </v-col>
                    <v-col :cols="2" class="flex-center">
                      <img
                        :src="require('../../assets/images/refresh.png')"
                        height="30"
                        id="captcha_refresh_image"
                        style="cursor: pointer"
                        align="center"
                        @click="captcha()"
                      />
                    </v-col>
                    <v-col :cols="6" class="flex-center">
                      <v-text-field
                        outlined
                        width="100%"
                        id="captcha_user_text"
                        v-model="captchaValue"
                        labelColor="white"
                        maxLength="8"
                        @keyup.enter="login"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn
                    v-text="$t('login')"
                    block
                    large
                    class="white--text"
                    color="#42a3f7"
                    @click="login"
                    :loading="loading"
                  >
                    <template v-slot:loader>
                      <v-progress-linear
                        style="margin-top: 40px"
                        color="white"
                        indeterminate
                        reverse
                      ></v-progress-linear>
                    </template>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import Login from "./mixin/Login";

export default {
  mixins: [Login]
};
</script>
<style lang="scss" scoped>
.c-blue {
  color: #42a3f7;
}
.h-70px {
  height: 70px !important;
}
.login-title {
  font-weight: bold;
  text-transform: capitalize;
  color: #464646;
}

.backgroundDiv {
  background-image: url("../../assets/images/backend1.png");
  height: 100%;
  background-size: cover;
}

.captchaImg {
  border: solid 1px #eee;
  cursor: pointer;
  width: 100%;
}

.flex-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/authorization/Login.vue